
import { Options, prop, Vue } from "vue-class-component";
import Skeleton from "@/app/ui/components/skeleton/index.vue";
import Checkbox from "primevue/checkbox";
import { SttHistorySuccessBooking } from "@/domain/entities/PrintReceipt";
import {
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { PrintReceiptController } from "@/app/ui/controllers/PrintReceiptController";
import { BookingController } from "@/app/ui/controllers/BookingController";
import { PrintDetailRequest } from "@/data/payload/api/BookingRequest";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { PrintDataEntitas } from "@/domain/entities/Booking";
import JsBarcode from "jsbarcode";
import generateThermalPDF from "../../../../bulk-print-resi/modules/bulk-label-resi-thermal";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import formatPrice from "@/app/infrastructures/misc/common-library/v2/FormatPrice";

class Props {
  column = prop<any[]>({
    default: () => [],
    type: Array
  });
  data = prop<SttHistorySuccessBooking[]>({
    default: () => [],
    type: Array
  });
  loading = prop<boolean>({
    default: false,
    type: Boolean
  });
  errorType = prop<string>({
    default: "",
    type: String
  });
}

@Options({
  components: {
    Skeleton,
    Checkbox
  },
  emits: ["request"],
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler() {
        this.isSelectAll();
      }
    }
  }
})
class TableHistorySuccessBooking extends Vue.with(Props) {
  get lastBooking() {
    const last = PrintReceiptController.lastDateSttSuccessBooking;
    if (!last) return "";

    return formatDate(
      PrintReceiptController.lastDateSttSuccessBooking,
      "DD MMM YYYY, HH:mm"
    );
  }

  isAll = false;
  onCheckAll(value: boolean) {
    this.isAll = value;
    this.data.forEach((item) => {
      item.selected = value;
    });

    this.$emit("update:data", this.data);
  }

  isSelectAll() {
    this.isAll =
      this.data.length > 0 && this.data.every((item) => item.selected);
  }

  get selectedData() {
    const selected = this.data.filter((item) => item.selected);

    const selectedVisibleAmount = selected.filter(
      (item) =>
        (!item.isCashless && !item.isDfod) || (!item.isCashless && !item.isCod)
    );
    const totalAmount = selectedVisibleAmount.reduce(
      (total, item) => total + item.amount,
      0
    );

    return {
      total: selected.length,
      amount: formatPrice(
        totalAmount,
        "",
        AccountController.accountData.accountCurrency
      ),
      data: selected
    };
  }

  request() {
    this.$emit("request");
  }
  async printThermal() {
    try {
      MainAppController.showLoading();

      for (const item of this.selectedData.data) {
        const language = item.productType === "INTERPACK" ? "en" : "id";
        const book: any = await import(
          "@/app/ui/views/shipment/booking/create-booking/payment-detail/book.vue"
        );

        await book.default.methods.printBasic(
          undefined,
          0,
          language,
          false,
          true,
          item.sttNo
        );
      }

      this.request();
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(error, "Print Thermal Gagal !", this.printThermal)
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  createInvoice() {
    this.$emit("close");

    PrintReceiptController.setSelectedSttHistorySuccessBooking(
      this.selectedData.data
    );
    PrintReceiptController.setVisiblePreviewInvoice(true);
  }

  onReset() {
    this.onCheckAll(false);
    PrintReceiptController.resetListSttSuccessBooking();
    PrintReceiptController.setLastDateSttSuccessBooking();
    this.$emit("reset");
  }

  // resi print
  resiListData: Array<PrintDataEntitas> = [];
  resetResiListData() {
    this.resiListData = [];
  }

  async printThermalBulk() {
    this.resetResiListData();
    MainAppController.showLoading();

    const batchSize = 10;
    const data = this.selectedData.data;

    for (let i = 0; i < data.length; i += batchSize) {
      const batch = data.slice(i, i + batchSize);

      await Promise.all(
        batch.map(async (item) => {
          await BookingController.getPrintDataByStt(
            new PrintDetailRequest({
              sttNo: item.sttNo,
              id: item.sttId,
              accountType:
                AccountController.accountData.account_type === "partner"
                  ? AccountController.accountData.account_type_detail.type
                  : AccountController.accountData.account_type
            })
          );

          this.resiListData.push(BookingController.generatePrintData);
        })
      );
    }

    await this.printDocListStt();
    MainAppController.closeLoading();
  }

  async printDocListStt() {
    const listSttPieces: any = [];

    this.resiListData.forEach((item, index) => {
      if (item) {
        const barcode = document.createElement("img");
        const vendorBarcode = document.createElement("img");
        JsBarcode(barcode, item.sttNo, {
          textAlign: "left",
          displayValue: false,
          fontSize: 16
        });
        if (item.sttVendorRefferenceNo) {
          // vendor ref code
          JsBarcode(vendorBarcode, item.sttVendorRefferenceNo, {
            textAlign: "left",
            displayValue: false,
            fontSize: 16
          });
        }

        item.sttPieces.forEach((e) => {
          listSttPieces.push({
            ...e,
            ...item,
            barcode: barcode.src,
            vendorRefCode: vendorBarcode.src
          });
        });

        barcode.remove();
        vendorBarcode.remove();
      }
    });

    if (listSttPieces.length) {
      new Promise(function(resolve) {
        MainAppController.showLoading();
        setTimeout(resolve.bind(null, null), 1);
      }).then(() => {
        const accountType = AccountController.accountData.account_type;
        generateThermalPDF(accountType, listSttPieces, []);

        MainAppController.closeLoading();
      });
    }
  }
}
export default TableHistorySuccessBooking;
